const { atom } = require("recoil");

export const showPopupAtom=atom({
    key: "showPopupAtom",
    default:false,
})